import { Criteria } from '../../interfaces';

export const criteria: Criteria = {
    _id: '1',
    provider: 'meli',
    userId: '1',
    criteria: {
        pickupZone: {
            path: [
                {
                    lat: 54,
                    lng: 49,
                },
            ],
        },
    },
};

export const newCriteria: Criteria = {
    _id: '2',
    provider: 'meli',
    userId: '1',
    criteria: {
        pickupZone: {
            path: [
                {
                    lat: 53,
                    lng: 50,
                },
            ],
        },
    },
};

export const editedCriteria: Criteria = {
    _id: '2',
    provider: 'meli',
    userId: '1',
    criteria: {
        pickupZone: {
            path: [
                {
                    lat: 50,
                    lng: 49,
                },
            ],
        },
    },
};
